/* Aligns the "content" of the page with the navigation menu. */
.mainBody {
    margin-left: 300px;
}

/* The Col that contains the page header and page content. Adjacent to the navigation bar. */
.headerAndContentContainer {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
}